import axiosInstance from "../../../Utils/axios";
import axios from "axios";
let cancelToken;

//obtaining the paginated data
export const getCarpetType = (postsPerPage) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`api/v1/order/carpet-type?offset=0&limit=${postsPerPage}&ordering=-id`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllCarpetType = () => axiosInstance.get(`api/v1/order/carpet-type?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCarpetType = (number, postsPerPage) =>
  axiosInstance.get(
    `api/v1/order/carpet-type?offset=${(number - 1) * postsPerPage}&limit=${postsPerPage}&ordering=-id`
  );

//creating function
export const createCarpetType = (body) => axiosInstance.post(`api/v1/order/carpet-type`, body);
//updating function
export const updateCarpetType = (id, body) => axiosInstance.patch(`api/v1/order/carpet-type/${id}`, body);

//searching function
export const handleSearch = (search, postsPerPage) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`api/v1/order/carpet-type?offset=0&limit=${postsPerPage}&search=${search}`, {
    cancelToken: cancelToken.token,
  });
};

// checking the redundant data
export const checkRedundantDataCarpetTypeName = (e, cancelToken) =>
  axiosInstance.get(`api/v1/order/carpet-type?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
